import { Helpers } from "../../core/src/helpers";
import { EtrAPI } from "../../core/src/etr-api-client";

export const fetchBreadcrumbs = Helpers.memoize((productId, modelId) => {
    return EtrAPI.breadcrumb.get(productId, modelId).then((resp) => {
        if(resp.status === 200) {
            let bc = resp.data;
            return bc.match(/<span>(.*?)<\/span>/g);
        }
    })
    .catch((err) => {
        console.log(err);
    });
});
